import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ysCamera",
  "use": "icon-ysCamera-usage",
  "viewBox": "0 0 1146 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1146 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ysCamera\"><defs><style type=\"text/css\"></style></defs><path d=\"M240.8448 705.37216H120.4224v-153.6L0 529.12128V1024l120.4224-39.77216V813.4656H315.392l103.2192-142.21312-137.6256-74.01472-40.1408 108.1344z m625.0496 28.38528L1146.88 557.34272 275.2512 0H172.032L34.4064 210.5344v73.97376L802.816 739.61472l63.0784-5.85728z m-103.2192 39.81312L103.2192 352.6656 34.4064 426.72128l768.4096 455.0656h68.8128l34.4064-34.2016 34.4064-102.4L837.2224 819.2c-45.99808-34.24256-74.5472-45.62944-74.5472-45.62944z\" p-id=\"1762\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ysCamera.svg
// module id = P4wN
// module chunks = 81